import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { HuntDashboardComponent } from './hunt-dashboard/hunt-dashboard.component';
import { HuntBonesComponent } from './hunt-bones/hunt-bones.component';
import { HuntImportComponent } from './hunt-import/hunt-import.component';
import { HuntScheduleComponent } from './hunt-schedule/hunt-schedule.component';
import { HuntFindsComponent } from './hunt-finds/hunt-finds.component';
import { HuntSettingsComponent } from './hunt-settings/hunt-settings.component';
import { HuntActivityComponent } from './hunt-activity/hunt-activity.component';
import { IstPipe, DurationPipe } from './hunt-format.pipe';

/**
 * "Explorer" section: admin for Tilo's Spark Bone hunt in GoFloaters Explorer.
 * Talks to the sparkhunt admin API (see hunt-api.service.ts).
 * Routes are children of /landingpage, added in app.module.ts via EXPLORER_ROUTES.
 */
export const EXPLORER_ROUTES: Routes = [
  { path: 'explorer', redirectTo: 'explorer/dashboard', pathMatch: 'full' },
  { path: 'explorer/dashboard', component: HuntDashboardComponent },
  { path: 'explorer/bones', component: HuntBonesComponent },
  { path: 'explorer/import', component: HuntImportComponent },
  { path: 'explorer/schedule', component: HuntScheduleComponent },
  { path: 'explorer/finds', component: HuntFindsComponent },
  { path: 'explorer/settings', component: HuntSettingsComponent },
  { path: 'explorer/activity', component: HuntActivityComponent },
];

/** Menu entry for the landing page's side menu. */
export const EXPLORER_NAV = {
  displayName: 'Explorer',
  iconName: 'paw',
  children: [
    { displayName: 'Hunt Dashboard', route: '/landingpage/explorer/dashboard' },
    { displayName: 'Bones', route: '/landingpage/explorer/bones' },
    { displayName: 'Import Bones', route: '/landingpage/explorer/import' },
    { displayName: 'Schedule', route: '/landingpage/explorer/schedule' },
    { displayName: 'Finds', route: '/landingpage/explorer/finds' },
    { displayName: 'Hunt Settings', route: '/landingpage/explorer/settings' },
    { displayName: 'Activity Log', route: '/landingpage/explorer/activity' },
  ],
};

@NgModule({
  declarations: [
    HuntDashboardComponent,
    HuntBonesComponent,
    HuntImportComponent,
    HuntScheduleComponent,
    HuntFindsComponent,
    HuntSettingsComponent,
    HuntActivityComponent,
    IstPipe,
    DurationPipe,
  ],
  imports: [CommonModule, FormsModule, RouterModule],
})
export class ExplorerHuntModule {}
